import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import {
  buildGroupSalesMultiContentHtml,
  GroupSalesMultiSnapshot,
} from '@/components/Approval/@components/GroupSales';
import { getGroupSalesMultiDraftSourceUrl } from '@/constant/approval';
import { getNestedDataFetcher } from '@/utils/apis';
import {
  groupSalesMultiItems,
  parseGroupSalesMultiAttributes,
  type GroupSalesMultiDraftSource,
} from '@/utils/approval/groupSalesMulti';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 131 단체판매 진행(다중) — 저장 content(작성 시점, 레거시 문서 포함) 그대로. content 가 없을 때만 지금 내역 */
const GroupSalesMultiSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const saved = parseGroupSalesMultiAttributes(data.attributes);
  const needsLive = !!saved && !saved.content;
  const { data: source } = useSWR<GroupSalesMultiDraftSource>(
    saved && needsLive
      ? getGroupSalesMultiDraftSourceUrl({
          brandCode: saved.group.brand,
          saleType: saved.group.type,
          items: groupSalesMultiItems(saved.group),
        })
      : null,
    getNestedDataFetcher,
    { revalidateOnFocus: false },
  );
  const liveContent = useMemo(
    () =>
      saved && source
        ? buildGroupSalesMultiContentHtml(
            saved.group,
            source.display.items ?? [],
            t,
          )
        : null,
    [source, t],
  );
  const content = saved?.content ?? liveContent;
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <GroupSalesMultiSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default GroupSalesMultiSlot;
